// extracted by css-extract-rspack-plugin
module.exports =  {"container":"PasteListModal-GHUf__container","introduction-text":"PasteListModal-n8kb__introduction-text"};